module.exports = __webpack_public_path__ + "media/images/dmc/tour-04-0d4b7f6f71402166e5afab9cb0d1711d.jpg";